import { jsx } from '@emotion/core';
import { StyledHeader } from './baseStyles';

var H1 = function H1(_a) {
  var children = _a.children,
      _b = _a.margin,
      margin = _b === void 0 ? 'xsmall' : _b,
      className = _a.className;
  return jsx(StyledHeader, {
    as: "h1",
    fontWeight: 300,
    margin: margin,
    className: className
  }, children);
};

export default H1;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Type/H1.js
// module id = 807
// module chunks = 0